import { Component, OnInit, Inject } from '@angular/core';

import { ProjectInfo } from '../model/project.model';
import { EmpRoleInfo } from '../model/emprole.model';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { Router } from '@angular/router';
import { TokenService } from '../service/token.service';


let today = new Date().toISOString()



@Component({
  selector: 'app-select-project',
  templateUrl: './select-project.component.html',
  styleUrls: ['./select-project.component.css']
})
export class SelectProjectComponent implements OnInit {

  ProjectOnPromise: Promise<ProjectInfo[]>
  projectList: ProjectInfo[]
  countprojectlist: number;

  EmpRoleOnPromise: Promise<EmpRoleInfo[]>
  EmpRoleList: EmpRoleInfo[]


  public currentPageNumber: number
  public totalPages: number
  RoleCode : any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }


  async ngOnInit() {
    this.currentPageNumber = 1;
   
    this.LoadProject();
   

  }
  ///////////////////////////////////////Events////////////////////////////////////////////

  ///////////////////////////////////////Functions/////////////////////////////////////////

  LoadProject() {
    this.LoadProjectList()
      .then(
        data => {
          this.projectList = data
          if (data.length == 1) {
            this.router.navigate(['issue-management', { ProjectCode: data[0].ProjectCode, ProjectName: data[0].ProjectName }])
          }
        }
      )
    
  }

  async LoadProjectList(): Promise<ProjectInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      let EmpCode = "";
      let UserName = "";
      if (typeof (Storage) !== "undefined") {

        EmpCode = localStorage.getItem("EmpCode")
        UserName = localStorage.getItem("UserName")

      }

      //Get Emp Role 
      let strjson = "{\"EmpCode\": \"" + EmpCode + "\" " +
        "}";


      await this.httpClient
        .post<EmpRoleInfo[]>(this.baseurl + "Employee/GetEmployeeRoleCriteria",
          strjson, httpOptions).toPromise()
        .then(
          data => {
            this.EmpRoleList = data

            for (let item of this.EmpRoleList) {

              this.RoleCode = item.RoleCode
            }
          }
        )
      //End  Get Emp Role 

      if (this.RoleCode == "MANAGER" || this.RoleCode == "PROJECTCO" || this.RoleCode == "DIRECTOR" || this.RoleCode == "SALEDIRECTOR" || this.RoleCode == "PROJDIRECTOR" || this.RoleCode == "HRMANAGER") { // Check หัวหน้าเห็นหมด


        //strjson = "{" +
        //  "\"ProjectCode\": \"\"" +
        //  "}";

        //strjson = "{\"UserName\": \"" + UserName + "\", " +
        //  "\"EmpCode\": \"" + EmpCode + "\", " +
        //  "\"rowFetch\": 0, " +
        //  "\"rowOFFSet\": 0," +
        //  "\"FlagDelete\": \"N\"" +
        //  "}";

        var objectjson = {};
        objectjson["UserName"] = UserName;
        if (this.RoleCode == "MANAGER" || this.RoleCode == "PROJECTCO" || this.RoleCode == "HRMANAGER") objectjson["EmpCode"] = EmpCode; //filter by emp
        objectjson["rowFetch"] = 0;
        objectjson["rowOFFSet"] = 0;
        objectjson["FlagDelete"] = "N";

        let strjson = JSON.stringify(objectjson);


        this.ProjectOnPromise = this.httpClient
          .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria",
            strjson, httpOptions)
          .toPromise()

      } else {

        strjson = "{\"UserName\": \"" + UserName + "\", " +
          "\"EmpCode\": \"" + EmpCode + "\", " +
          "\"rowFetch\": 0, " +
          "\"rowOFFSet\": 0," +
          "\"FlagDelete\": \"N\"" +
          "}";




        this.ProjectOnPromise = this.httpClient
          .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectbyMemberCriteria",
            strjson, httpOptions)
          .toPromise()
      }

      return this.ProjectOnPromise;
    }
  }

  displayimgProject(projectcode) {
    return "/Project/Img/" + projectcode;
  }



}
